/**
 * The DecisionSet the preview Worker runs, from the team's draft. Only `decisions` drive the preview: the Worker re-expands
 * `fine` from them (preview-worker/core.ts), so it is a placeholder here.
 */
import type { DraftView } from "@bsim/contracts";
import type { DecisionSet, FineDecisions, PreviewInput, Provenance } from "@bsim/domain";

const DERIVED: Provenance = { kind: "derived", source: "autopilot" };
/** A placeholder field: the Worker never reads `fine`, so the value takes whatever branded type its slot asks for. */
const p = (value: unknown): { readonly value: never; readonly provenance: Provenance } => ({ value: value as never, provenance: DERIVED });

const PLACEHOLDER_FINE: FineDecisions = {
  loans: [], deposits: [],
  funding: { shortfallMix: p({ fhlbShortRate: 1, fhlbTermRate: 0, brokeredRate: 0 }), bufferAboveCashFloorUsd: p(0), dwPrepledge: p(false) },
  securities: { targetShareOfAssetsRate: p(0), newBuys: p([{ bookId: "ust_afs", durationYears: 1, weightRate: 1 }]) },
  hedges: { targetPayFixedNotionalUsd: p(0), tenorYears: p(1) },
  capital: { dividend: p({ payoutRate: 0, sticky: false }), buyback: p({ mode: "off" }), issuanceUsd: p(0) },
  operations: {
    controllableOpexChangeRate: p(0), oneTimeChargeUsd: p(0), fteDelta: p(0), serviceIndexDelta: p(0), techInvestUsdByTheme: p({}),
    branchesDelta: p(0), compChangeRate: p(0), trainingUsd: p(0), feeScheduleMult: p(1),
  },
  flags: [],
};

export const draftDecisionSet = (input: PreviewInput, draft: DraftView): DecisionSet => ({
  seatId: input.seatId, round: input.round, schemaVersion: 2, decisions: draft.decisions, fine: PLACEHOLDER_FINE,
  eventResponses: [], rationales: [], forecasts: [], thesis: draft.thesis.text, signoff: {},
});
